import { makeApiCallWithAny } from "./tokenService";
import { ITypedOption } from "../models/common/typedOptions";

export const getOwnerOptions = (
    signal?: AbortSignal
): Promise<ITypedOption[]> => {
    return makeApiCallWithAny("api/option", signal);
};
